import { NetworkDeepDiveMapComponent } from './network-deep-dive-map/network-deep-dive-map.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    component: NetworkDeepDiveMapComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NetworkDeepDiveMapRoutingModule { }
